import React from "react";
import styles from './styles.module.scss'

export default function NotFound () {
  return <div className={styles.content}>
    <div className={styles.bg}></div>
    <a href="/">服务发生了错误，回到首页</a>
  </div>
}
